<header-bar [pageTitle]="title" headingClass="fa-user-o"></header-bar>
<div class="container mt-5">
    <div class="row">
        <div class="col">
            <form [formGroup]="dropDownForm" (ngSubmit)="saveClicked(dropDownForm.value, dropDownForm.valid)"
                novalidate>
                <div class="card">
                    <div class="card-header bg-primary text-white">
                        <div class="row align-items-center">
                            <p class="h3 m-0 col">{{title}}</p>
                            <div class="col text-right">
                                <button type="submit" class="btn btn-outline-light btn-sm"
                                    [disabled]="!dropDownForm.valid">
                                    Save Changes
                                    <i class="fa fa-check ml-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <p class="textBody--xs u-marginBottom--medium">Please complete all fields marked with an
                                    asterix (*)</p>

                                <div class="row">
                                    <div class="col">
                                        <div class="form-group"
                                            [ngClass]="{ 'has-error': !dropDownForm.controls['presentationType'].valid && dropDownForm.controls['presentationType'].touched }">
                                            <label for="tbname" class="textBody--sm">Presentation type *</label>
                                            <ng-select 
                                                [items]="types" 
                                                [placeholder]="'Select presentation type'"
                                                (selected)="onNgSelectPresentationTypeChange($event)"
                                                formControlName="presentationType"
                                                [allowClear]="true"
                                                [disabled]="dropDownForm.get('presentationType').disabled">
                                            </ng-select>
                                            <div *ngIf="dropDownForm.controls['presentationType'].hasError('required') && dropDownForm.controls['presentationType'].touched"
                                                class="alert alert-danger">You must select a presentation type.</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group"
                                            [ngClass]="{ 'has-error': !dropDownForm.controls['label'].valid && dropDownForm.controls['label'].touched }">
                                            <label for="tbname" class="textBody--sm">Label *</label>
                                            <input type="text" formControlName="label" class="form-control"
                                                maxlength="100" />
                                            <div *ngIf="dropDownForm.controls['label'].hasError('required') && dropDownForm.controls['label'].touched"
                                                class="alert alert-danger">You must include a label.</div>
                                            <div *ngIf="dropDownForm.controls['label'].hasError('trimmedminlength') && dropDownForm.controls['label'].touched"
                                                class="alert alert-danger">Label must be at least 3 characters long.
                                            </div>
                                            <div *ngIf="dropDownForm.controls['label'].hasError('maxlength') && dropDownForm.controls['label'].touched"
                                                class="alert alert-danger">Label cannot exceed 100 characters.</div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="selectedPresentationType && selectedPresentationType.id == dropDownPresentationType.DropDown"
                                    class="form-group">
                                    <label for="tballowmultiple">Allow multiple select</label>
                                    <p class="textBody--xs">
                                        <input type="checkbox" id="tballowmultiple" name="tballowmultiple"
                                            formControlName="allowMultiple" class="u-marginTop--small " />
                                        If checked this item will allow multiple items to be selected when providing
                                        location data.
                                    </p>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label for="tbdescription" class="textBody--sm">Description *</label>
                                            <textarea id="tbdescription" name="tbdescription" rows="3"
                                                formControlName="description" class="form-control"
                                                maxlength="200"></textarea>
                                            <div *ngIf="dropDownForm.controls['description'].hasError('required') && dropDownForm.controls['description'].touched"
                                                class="alert alert-danger">You must include a Description.</div>
                                            <div *ngIf="dropDownForm.controls['description'].hasError('trimmedminlength') && dropDownForm.controls['description'].touched"
                                                class="alert alert-danger">Description must be at least 3 characters
                                                long.</div>
                                            <div *ngIf="dropDownForm.controls['description'].hasError('maxlength') && dropDownForm.controls['description'].touched"
                                                class="alert alert-danger">Description cannot exceed 200 characters.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label for="tbhelptext" class="textBody--sm">Help text</label>
                                            <input type="text" id="tbhelptext" name="tbhelptext"
                                                formControlName="helpText" class="form-control" />
                                            <div *ngIf="dropDownForm.controls['helpText'].hasError('maxlength') && dropDownForm.controls['helpText'].touched"
                                                class="alert alert-danger">Help text cannot exceed 50 characters.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="container mt-5" *ngIf="dropDown?.id > 0">
    <div class="row">
        <div class="col">
            <div class="card">
                <div class="card-header bg-primary text-white">
                    <div class="row align-items-center">
                        <p class="h3 m-0 col">Manage drop down items</p>
                        <div class="col text-right">
                            <button type="submit"
                                *ngIf="selectedPresentationType && selectedPresentationType.id == dropDownPresentationType.DropDown"
                                class="btn btn-outline-light btn-sm" [disabled]="!dropDownForm.valid"
                                (click)="prepopulateClicked()">
                                Prepopulate from list
                                <i class="fa fa-check ml-2"></i>
                            </button>
                            <button type="submit" class="btn btn-outline-light btn-sm" [disabled]="!dropDownForm.valid"
                                (click)="addDropDownItemClicked()">
                                Add drop down item
                                <i class="fa fa-check ml-2"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="card-body">
                    <p class="textBody--sm u-marginBottom--x-large">
                        <strong>Drag and drop</strong> items to re-order how items appear on the page.
                        <strong>To modify an existing drop down item</strong> select the
                        <i class="fa fa-pencil"></i>.</p>

                    <div class="row mt-3">
                        <div class="col">
                            <ul class="list-group mt-3" 
                                cdkDropList 
                                [cdkDropListData]="dropDown?.items"
                                (cdkDropListDropped)="onDrop($event)">
                                <li *ngFor="let item of dropDown?.items; let i = index;"
                                    class="list-group-item d-flex justify-content-between align-items-center drag-item"
                                    [ngClass]="{'list-group-item-secondary': item.disabled}"
                                    cdkDrag
                                    [cdkDragData]="item">
                                    <div class="d-flex align-items-center" cdkDragHandle title="Drag to reorder">
                                        <div class="drag-handle me-3">
                                            <i class="fa fa-bars"></i>
                                        </div>
                                        <span [ngClass]="{'text-muted': item.disabled}">{{item.text}}</span>
                                        <span *ngIf="item.disabled" class="badge badge-secondary ml-2">Disabled</span>
                                    </div>
                                    <div class="btn-group" role="group">
                                        <button type="button" class="btn edit-btn" 
                                                (click)="dropDownItemClicked(item)" 
                                                title="Edit item">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<confirmationmodal #confirmModal (onAccept)="onAccept();" (onDecline)="onDecline();"></confirmationmodal>
